import React from 'react';
import Icon from 'components/AppIcon';
import { formatKES } from '../../../services/invoiceService';

const InvoiceStatsCards = ({ analytics, loading }) => {
  const cards = [
    {
      label: 'Total Outstanding',
      value: formatKES(analytics?.outstanding || 0),
      icon: 'TrendingUp',
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      border: 'border-amber-200'
    },
    {
      label: 'Total Paid',
      value: formatKES(analytics?.totalPaid || 0),
      icon: 'CheckCircle',
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      border: 'border-emerald-200'
    },
    {
      label: 'Overdue Amount',
      value: formatKES(analytics?.overdue || 0),
      icon: 'AlertTriangle',
      color: 'text-red-600',
      bg: 'bg-red-50',
      border: 'border-red-200'
    },
    {
      label: 'Collection Rate',
      value: `${analytics?.collectionRate || 0}%`,
      icon: 'BarChart2',
      color: 'text-primary',
      bg: 'bg-primary-50',
      border: 'border-primary-200'
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[1,2,3,4]?.map(i => (
          <div key={i} className="bg-surface rounded-xl border border-border p-4 animate-pulse">
            <div className="h-4 bg-secondary-100 rounded w-3/4 mb-3" />
            <div className="h-7 bg-secondary-100 rounded w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards?.map((card) => (
        <div key={card?.label} className={`bg-surface rounded-xl border ${card?.border} p-4`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-body-medium text-text-secondary">{card?.label}</span>
            <div className={`w-8 h-8 ${card?.bg} rounded-lg flex items-center justify-center`}>
              <Icon name={card?.icon} size={16} className={card?.color} />
            </div>
          </div>
          <p className={`text-lg font-heading-semibold ${card?.color}`}>{card?.value}</p>
          <div className="flex gap-3 mt-2">
            <span className="text-xs text-text-secondary">
              {card?.label === 'Collection Rate'
                ? `${analytics?.paidCount || 0} paid invoices`
                : card?.label === 'Total Outstanding'
                ? `${analytics?.sentCount || 0} sent`
                : card?.label === 'Overdue Amount'
                ? `${analytics?.overdueCount || 0} overdue`
                : `${analytics?.totalInvoices || 0} total`
              }
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceStatsCards;
